<template>
    <div>

         <!-- banner Start -->
    <div class="banner-sec">
        <div class="header-img">
            <img src="@/assets/images/contact.jpg" class="w-100">
            <div class="contents">
                <h1>Contact Us</h1>
                <p>How can we help you?</p>
            </div>
        </div>
    </div>
    <!-- banner end -->
   <!-- Contact Us Start -->
   <div class="contact-us-section">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-3 mb-3" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="800">
                    <div class="row contact-details mb-4">

                        <div class="col-lg-4">
                            <div class="contact-box">
                                <div class="border-right">
                                    <img src="@/assets/images/location.png" class="max-50">
                                </div>
                                <div>
                                    <h5 class="text-center">Address</h5>
                                    <p class="text-center">
Office No. 401 to 404, 4th Floor,<br />
BAY VIEW by SOLARIS,<br />
B/S Iscon Mall, Dumas Road,<br />
Piplod, Surat-395007, Gujarat, India.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="contact-box">
                                <div class="border-right">
                                    <img src="@/assets/images/phone.png" class="max-50">
                                </div>
                                <div>
                                    <h5 class="text-center">Phone Number</h5>
                                    <p class="text-center">
                                        <a href="tel:+919512018592">+91 95120 18592</a>
                                        <!-- <a href="tel:+91 261 289 7747">+91-261-289-7747</a> -->
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="contact-box">
                                <div class="border-right">
                                    <img src="@/assets/images/open-mail.png" class="max-50">
                                </div>
                                <div>
                                    
                                    <h5 class="text-center">Email</h5>
                                    <p class="text-center">
                                        <a href="mailto:admin@pratibhagroup.in">admin@pratibhagroup.in</a><br />
                                        <a href="mailto:office@pratibhagroup.in">office@pratibhagroup.in</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <!-- Contact Us End -->
    </div>
  </template>

  
<script>

// aos animation 
import AOS from 'aos'
import 'aos/dist/aos.css'
import 'animate.css/animate.min.css'

 export default {
          name: "contact",
          created() {
          document.title = "Contact Us - Pratibha Group";
          },
          mounted() {
              this.init();
          },
          methods: {
              init() {
                  this.aosAnimation();
              },
              aosAnimation(){
                  AOS.init({
                      easing: 'ease-in-out-sine'
                  });
              }
          }
      
  }
</script>